/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelJournalSales.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/journal-sales";

export class AutogenModelJournalSales<RowType extends ModelRow> extends Endpoint<RowType, RowJournalSalesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowJournalSales extends ModelRow<RowJournalSalesFields> {
	constructor(values?: Partial<RowJournalSalesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowJournalSalesFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	batch_code: string;
	batch_number: number;
	batch_seq: number;
	company_from: string;
	company_id: string;
	correction: string;
	customer_id: string;
	export_date: Date;
	exported: string;
	glid: string;
	gp_exported: Date;
	id: string;
	import_date: Date;
	invoice_no: number;
	invoice_no_string: string;
	is_intercompany: string;
	ltl_id: number;
	order_id: string;
	post_date: Date;
	post_key: string;
	post_key_openitem: string;
	post_module: string;
	transaction_date: Date;
	via_terminal_id: string;
}

